export default {
  SET_CARD_GROUP_LIST(state, payload) {
    state.cardGroupList = payload;
  },
  SET_LEARNING_RESULT(state, payload) {
    state.learningResult = payload;
  },
  SET_CARD_LIST(state, payload) {
    state.cardList = payload;
  },
  SET_TIME_STUDY_AVG(state, payload) {
    state.timeStudyAvg = payload;
  },
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  },
  SET_PAGINATION(state, payload) {
    state.pagination = payload;
  },
  SET_CARD_LIST_PAGINATION(state, payload) {
    state.cardListPagination = payload;
  },
  SET_LEARN_RETURN_PAGE(state, payload) {
    state.learnReturnPage = payload;
  },
  setSlotParentEventController(state, payload) {
    state.slotParentEventController++;
    state.newProCardGroupPayload = payload;
  },
};
